import PropTypes from 'prop-types';
// @mui
import { Typography, Stack } from '@mui/material';
// components
import Logo from '../../components/minimal/logo';
import Image from '../../components/minimal/image';
//
import { StyledRoot, StyledSectionBg, StyledSection, StyledContent } from './styles';
import { getMarketplaceAuthImage, getMarketplaceAuthImageMobile } from '../../utils/market';

// ----------------------------------------------------------------------

AuthLayout.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
  illustration: PropTypes.string,
};

export default function AuthLayout({ children, illustration, title, subTitle, onlyImage = true }) {
  const authImageDesktop = getMarketplaceAuthImage();
  const authImageMobile = getMarketplaceAuthImageMobile();
  const overlay = 'linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.5))';
  return (
    <StyledRoot
      sx={authImageMobile ? {
        backgroundImage: { xs: `${overlay}, url(${authImageMobile})`, md: 'none' },
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      } : undefined}
    >

        <Logo
            sx={{
                zIndex: 9,
                position: 'absolute',
                right: { xs: 0, md: 40 },
                left: { xs: 0, md: 'auto' },
                mx: { xs: 'auto', md: 0 },
                width: { xs: 'fit-content', md: 'auto' },
                mt: { xs: 1.5, md: 5 },
                ml: { xs: 'auto', md: 5 },
            }}
        />

      <StyledContent sx={(theme) => ({
          [theme.breakpoints.down('md')]: {
              paddingTop: theme.spacing(6),
              ...(authImageMobile && {
                  '& .login-title': {
                      display: 'none',
                  },
                  '& .MuiOutlinedInput-root, & .MuiFilledInput-root, & .MuiInputBase-root': {
                      backgroundColor: 'rgba(255, 255, 255, 0.92)',
                  },
                  '& .MuiButton-contained': {
                      backgroundColor: 'transparent',
                      color: '#fff',
                      border: '1px solid rgba(255, 255, 255, 0.8)',
                      '&:hover': {
                          backgroundColor: 'rgba(255, 255, 255, 0.12)',
                      },
                  },
              }),
          },
      })}>
         <Stack sx={{ width: 1 }}> {children} </Stack>
      </StyledContent>


      { onlyImage
          ? <StyledSection sx={{
              direction: "rtl",
              backgroundImage: `${overlay}, url(${authImageDesktop})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
          }} />
          : <StyledSection>

              <Typography variant="h3" sx={{ maxWidth: 480, textAlign: 'center' }}>
                  {title}
              </Typography>

              {
                  subTitle ? <Typography variant="h6" sx={{ maxWidth: 480, mt: 2, textAlign: 'center' }}>{subTitle}</Typography> : null
              }

              <Image
                  disabledEffect
                  visibleByDefault
                  alt="auth"
                  src={illustration || '/assets/illustrations/illustration_dashboard.png'}
                  sx={{ maxWidth: 720, mt: 10 }}
              />

              <StyledSectionBg />
          </StyledSection>
      }




    </StyledRoot>
  );
}
